import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface UsedInvitation {
  invitationDate: string;
  customerName: string;
  number: string;
  nationalId: string;
}

export interface UsedInvitationsDialogData {
  subscriptionId?: number;
  invitations?: UsedInvitation[];
}

@Component({
  selector: "fury-invitation",
  templateUrl: "./invitation.component.html",
  styleUrls: ["./invitation.component.scss"],
})
export class InvitationComponent {
  activeTab: "date" | "customer" | "number" | "nationalId" = "nationalId";
  invitations: UsedInvitation[] = [];

  constructor(
    private dialogRef: MatDialogRef<InvitationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UsedInvitationsDialogData,
  ) {}

  ngOnInit(): void {
    // Load invitations from data
    if (this.data?.invitations) {
      this.invitations = this.data.invitations;
    }

    // Example data for demo (remove in production):
    // this.invitations = [
    //   {
    //     invitationDate: '2026-02-15',
    //     customerName: 'Ahmed Mohamed',
    //     number: '01234567890',
    //     nationalId: '29501011234567',
    //   },
    //   {
    //     invitationDate: '2026-02-12',
    //     customerName: 'Sara Ali',
    //     number: '01098765432',
    //     nationalId: '29801051234568',
    //   },
    // ];
  }

  setActiveTab(tab: "date" | "customer" | "number" | "nationalId"): void {
    this.activeTab = tab;
  }

  getActiveTabLabel(): string {
    switch (this.activeTab) {
      case "date":
        return "Invitation Date";
      case "customer":
        return "Customer Name";
      case "number":
        return "Number";
      case "nationalId":
        return "National ID";
      default:
        return "";
    }
  }

  getActiveTabValue(invitation: UsedInvitation): string {
    switch (this.activeTab) {
      case "date":
        return invitation.invitationDate;
      case "customer":
        return invitation.customerName;
      case "number":
        return invitation.number;
      case "nationalId":
        return invitation.nationalId;
      default:
        return "";
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
